var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          "left-side-class": "col-xl-4",
          page: _vm.pageConfig,
          "right-side-class":
            "col-xl-8 align-items-end d-flex pb-2 justify-content-end"
        },
        scopedSlots: _vm._u([
          {
            key: "customActions",
            fn: function() {
              return [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col d-flex justify-content-end align-items-center"
                    },
                    [
                      _c("action-button", {
                        attrs: {
                          i: "fas fa-arrow-circle-left",
                          text: "Regresar",
                          variant: "outline-success"
                        },
                        on: {
                          click: function($event) {
                            return _vm.$router.go(-1)
                          }
                        }
                      }),
                      _vm.showMoveToPending
                        ? _c("action-button", {
                            attrs: {
                              i: "fas fa-undo-alt",
                              text: "Mover a Pendiente",
                              variant: "outline-success ml-3"
                            },
                            on: { click: _vm.moveToPendingHandler }
                          })
                        : _vm._e(),
                      _vm.showPayJournal
                        ? _c("action-button", {
                            attrs: {
                              i: "fas fa-check-circle",
                              text: "Pagar Jornal",
                              variant: "success ml-3"
                            },
                            on: { click: _vm.processPaymentJournal }
                          })
                        : _vm._e(),
                      _vm.showMarkAsProcessed
                        ? _c("action-button", {
                            attrs: {
                              i: "fas fa-check-circle",
                              text: "Marcar Procesado",
                              variant: "success ml-3"
                            },
                            on: { click: _vm.markAsProcessedHandler }
                          })
                        : _vm._e(),
                      _vm.showApproveBtn
                        ? _c("action-button", {
                            attrs: {
                              i: "fas fa-check",
                              text: "Aprobar pagos",
                              variant: "success ml-3"
                            },
                            on: { click: _vm.onApproveHandler }
                          })
                        : _vm._e(),
                      _vm.showUpdateJournal
                        ? _c("action-button", {
                            attrs: {
                              i: "fas fa-exchange-alt",
                              text: "Actualizar Jornal",
                              variant: "outline-success ml-3"
                            },
                            on: { click: _vm.onUpdateJournalHandler }
                          })
                        : _vm._e(),
                      _vm.showMarkAsPaid
                        ? _c("action-button", {
                            attrs: {
                              i: "fas fa-check",
                              text: "Marcar Pagado",
                              variant: "success ml-3"
                            },
                            on: { click: _vm.handleMarkAsPaid }
                          })
                        : _vm._e(),
                      _vm.showSendToFinance
                        ? _c(
                            "span",
                            {
                              attrs: {
                                title: !_vm.allStudentsVoucherRegistered
                                  ? "Quedan estudiantes pendientes de registrar voucher"
                                  : ""
                              }
                            },
                            [
                              _c("action-button", {
                                attrs: {
                                  disabled: !_vm.allStudentsVoucherRegistered,
                                  i: "fas fa-paper-plane",
                                  text: "Enviar a Finanzas",
                                  variant: "success ml-3"
                                },
                                on: { click: _vm.handleSendToFinance }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showProcessPayment
                        ? _c(
                            "div",
                            { staticClass: "dropdown d-flex ml-3" },
                            [
                              _c(
                                "action-button",
                                {
                                  staticClass: "pt-1 success",
                                  attrs: {
                                    id: "action-dropdown",
                                    "aria-expanded": "false",
                                    "aria-haspopup": "true",
                                    "data-toggle": "dropdown",
                                    type: "button"
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-folders mt-1"
                                  }),
                                  _c("span", { staticClass: "px-2" }, [
                                    _vm._v("Archivos de Pagos")
                                  ]),
                                  _c("i", { staticClass: "fa fa-angle-down" })
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right",
                                  attrs: {
                                    "aria-labelledby": "action-dropdown"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dropdown-item cursor-pointer",
                                      on: { click: _vm.onProcessPaymentHandler }
                                    },
                                    [
                                      _c("em", {
                                        staticClass:
                                          "fas fa-flag pr-2 text-green"
                                      }),
                                      _c("span", [
                                        _vm._v("Procesar Archivos de Pagos")
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm.showPaymentProcess
        ? _c("payment-journal-process", {
            on: {
              "on-cancel": _vm.onCancelPaymentProcessHandler,
              "on-continue": _vm.onContinuePaymentProcessHandler
            }
          })
        : _vm._e(),
      _c("budget-info", {
        model: {
          value: _vm.budgetInfo,
          callback: function($$v) {
            _vm.budgetInfo = $$v
          },
          expression: "budgetInfo"
        }
      }),
      _c("journal-info", {
        staticClass: "mt-2",
        attrs: {
          "all-students-voucher-registered": _vm.allStudentsVoucherRegistered,
          "has-electronic-transfer-jornal-payment":
            _vm.hasElectronicTransferJornalPayment,
          "show-journal-type": _vm.hasElectronicTransferJornalPayment
        },
        on: {
          "remove-files": _vm.onRemoveFilesHandler,
          "restart-status": _vm.onRestartStatusHandler
        },
        model: {
          value: _vm.journalInfo,
          callback: function($$v) {
            _vm.journalInfo = $$v
          },
          expression: "journalInfo"
        }
      }),
      _vm.showPaymentFileInfo
        ? _c("payment-file-info", {
            staticClass: "mt-5",
            attrs: {
              "payment-journal-id": _vm.paymentJournalId,
              "payment-journal-status-id":
                _vm.journalInfo.paymentJournalStatusId
            }
          })
        : _vm._e(),
      _c("payment-info", {
        ref: "paymentInfoComponentRef",
        staticClass: "mt-5",
        attrs: { "show-journal-type": _vm.hasElectronicTransferJornalPayment },
        on: {
          "grouped-summary-updated": function($event) {
            _vm.groupedSummary = $event
          },
          "items-checked": _vm.onItemsCheckedHandler,
          "on-denegate-item": _vm.onDenegateHandler,
          "on-tab-changed": _vm.onTabChangedHandler
        },
        model: {
          value: _vm.journalInfo,
          callback: function($$v) {
            _vm.journalInfo = $$v
          },
          expression: "journalInfo"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }